import produce from "immer";
import {
    INVITETEMPLATES_SET,
    INVITETEMPLATES_SET_LOADING,
    INVITETEMPLATES_SET_SINGLE,
    INVITETEMPLATES_UPDATE
} from "../types";

const initialState = {
    inviteTemplates: [],
    inviteTemplate: null,
    loading: false,
};

const inviteReducer = produce((draft, action) => {
    switch (action.type) {
        case INVITETEMPLATES_SET:
            draft.inviteTemplates = action.inviteTemplates;
            draft.loading = false;
            break;

        case INVITETEMPLATES_SET_SINGLE:
            draft.inviteTemplate = action.inviteTemplate;
            draft.loading = false;
            break;

        case INVITETEMPLATES_SET_LOADING:
            draft.loading = action.loading;
            break;
        case INVITETEMPLATES_UPDATE:
            draft.inviteTemplate = action.updatedTemplate;
            const index = draft.inviteTemplates.findIndex(t => t.id === action.updatedTemplate.id);
            if (index !== -1) {
                draft.inviteTemplates[index] = action.updatedTemplate;
            }
            break;

        default:
            break;
    }
}, initialState);

export default inviteReducer;

